const NODE_ENV = process.env.NODE_ENV;

const development = require("./config.development");
const production = require("./config.production");

let config;
switch (NODE_ENV) {
	case "production":
		config = production;
		break;
	default:
		config = development;
		break;
}

module.exports = config;
